import StylizedMenuItem from './HOClevel'

export default StylizedMenuItem
